import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import materialsReducer from './materialsSlice'
import operationsReducer from './operationsSlice'
import certificatesReducer from './certificatesSlice'
import analyticsReducer from './analyticsSlice'
import equipmentReducer from './equipmentSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    materials: materialsReducer,
    operations: operationsReducer,
    certificates: certificatesReducer,
    analytics: analyticsReducer,
    equipment: equipmentReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
